import React from 'react';

export default function NuestrosProductos() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <h1 className="text-4xl font-bold text-center text-blue-700 mb-4">Nuestros Productos</h1>
      <p className="text-center text-gray-600 mb-10">
        Conoce nuestra innovadora playera inteligente diseñada para el monitoreo continuo de la salud.
        Ideal para personas mayores, atletas, o pacientes en recuperación.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <div className="space-y-6">
          <img src="/assets/playera1.jpg" alt="Playera Inteligente 1" className="rounded shadow" />
          <img src="/assets/playera2.jpg" alt="Playera Inteligente 2" className="rounded shadow" />
          <img src="/assets/playera3.jpg" alt="Playera Inteligente 3" className="rounded shadow" />
        </div>
        <div className="flex flex-col justify-center">
          <h2 className="text-2xl font-semibold mb-4">Beneficios de la Playera Inteligente</h2>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Monitorea signos vitales como ritmo cardíaco, temperatura corporal y oxigenación.</li>
            <li>Detecta malas posturas para evitar lesiones o dolores crónicos.</li>
            <li>Envía alertas en tiempo real a familiares o médicos.</li>
            <li>Ligera, cómoda y lavable.</li>
            <li>Conectividad vía WiFi o Bluetooth.</li>
          </ul>
          <p className="mt-6 text-gray-600">
            Nuestra playera inteligente es más que una prenda: es un aliado para tu bienestar.
          </p>
        </div>
      </div>
    </div>
  );
}
